"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    toggleFilterStateVariants: ()=>toggleFilterStateVariants,
    toggleFilterStates: ()=>toggleFilterStates,
    toggleFilterVariants: ()=>toggleFilterVariants
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const toggleFilterStateVariants = {
    enabled: {},
    disabled: {}
};
const toggleFilterStates = Object.keys(toggleFilterStateVariants);
const toggleFilterVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        containerSlot: 'focus-visible:ring-primary-8 relative flex w-full cursor-pointer items-center justify-between gap-2 transition duration-150 ease-in-out focus-visible:outline-none focus-visible:ring-2',
        labelContainerSlot: 'flex flex-col gap-1',
        labelSlot: 'cursor-pointer',
        helperTextSlot: 'text-body3'
    },
    variants: {
        state: {
            enabled: {
                containerSlot: 'hover:before:bg-primary-2 relative cursor-pointer before:absolute before:inset-0 before:-z-[1] before:-m-2 before:rounded-xl before:border-0 before:transition before:duration-300',
                labelSlot: 'text-primary-13 cursor-pointer',
                helperTextSlot: 'text-primary-13'
            },
            disabled: {
                containerSlot: 'cursor-not-allowed',
                labelSlot: 'text-primary-6 cursor-not-allowed',
                helperTextSlot: 'text-primary-6'
            }
        }
    },
    defaultVariants: {
        state: 'enabled'
    }
});
exports.toggleFilterStateVariants = __webpack_exports__.toggleFilterStateVariants;
exports.toggleFilterStates = __webpack_exports__.toggleFilterStates;
exports.toggleFilterVariants = __webpack_exports__.toggleFilterVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "toggleFilterStateVariants",
    "toggleFilterStates",
    "toggleFilterVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
